import styled from '@emotion/styled';
import dayjs from 'dayjs';
import React from 'react';

import useFetchSummaryNotes from 'App/hooks/useFetchSummaryNotes';
import { dateTimeSlashesFormat } from 'App/services/DateService';
import { localize } from 'App/utils';
import { patientPropType } from 'Shared/types';
import AccordionWrapper from '../../AccordionWrapper/AccordionWrapper';
import SafeHtmlOnly from '../../SafeHtmlOnly/SafeHtmlOnly';
import { activityPropType } from '../types';
import SummaryNoteSubject from './SummaryNoteSubject';

const SummaryNoteStyle = styled.div`
    margin-bottom: 5px;
`;

const SummaryNoteCreatorStyle = styled.div`
    font-size: 10px;
    color: var(--manatee);
`;

const SummaryNoteBodyStyle = styled.div`
    margin-left: 10px;
`;

const SummaryNoteWrapperStyle = styled.div`
    .accordion-title {
        button {
            margin-top: 0;
            margin-bottom: 10px;
            font-size: 16px;
        }
    }

    .accordion-wrapper {
        padding-top: 5px;
    }

    .accordion-body {
        border: solid 1px var(--silver);
        border-radius: 4px;
        padding: 10px;
        background-color: #eee;
        margin-top: 5px;
        margin-bottom: 15px;
        font-size: 12px;
        overflow-y: auto;
        max-height: 20em;
    }
`;

const SummaryNotesDisplay = ({ patient, activity }) => {
    const { data: summaryNotes, isLoading } = useFetchSummaryNotes(patient.id, activity.assessment.defaultNoteType);

    if (isLoading || !summaryNotes) {
        return null;
    }

    const summaryNotesList = Object.values(summaryNotes);
    if (!summaryNotesList.length) {
        return null;
    }

    return (
        <SummaryNoteWrapperStyle className="summary-notes-list-wrapper">
            <AccordionWrapper title="Previous summary notes:" defaultIsVisible stateKey="prevSummaryNotesAccordion">
                <div>
                    {summaryNotesList
                        .sort((a, b) => dayjs(b.createdOn).diff(a.createdOn))
                        .map((note) => (
                            <SummaryNoteStyle key={note.id}>
                                <SummaryNoteCreatorStyle>
                                    <span>
                                        <SummaryNoteSubject note={note} patientId={patient.id} />
                                        {' - '}
                                        {note.createdByUser
                                            ? `${note.createdByUser.firstName} ${note.createdByUser.lastName}`
                                            : 'Former User'}
                                        {' - '}
                                        {localize(note.createdOn, dateTimeSlashesFormat)}
                                    </span>
                                </SummaryNoteCreatorStyle>
                                <SummaryNoteBodyStyle>
                                    <SafeHtmlOnly>{note.body}</SafeHtmlOnly>
                                </SummaryNoteBodyStyle>
                            </SummaryNoteStyle>
                        ))}
                </div>
            </AccordionWrapper>
        </SummaryNoteWrapperStyle>
    );
};

SummaryNotesDisplay.propTypes = {
    patient: patientPropType.isRequired,
    activity: activityPropType.isRequired,
};

export default React.memo(SummaryNotesDisplay);
